import React, { useEffect, useState } from 'react'
import apiService from '../../api/ApiService'
import { ChangeCircle, Delete, Edit } from '@mui/icons-material'
import S from '../../pages/ListDam.module.css'
import EditStatus from './Modals/EditStatusMOdal'
import { useGlobalContext } from '../Context'
import { useDispatch, useSelector } from 'react-redux'
import { AddStatus } from '../../redux/slices/warningSlice'
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import CycleOrderModal from './Modals/CycleOrderMOdal'
import DeleteComm from '../deleteComment'
import { Switch } from '@mui/material'
const colors=['red','yellow','blue','yellowgreen','green']
const CattleStatusList = ({flag}) => {
    const {currentWarings}=useSelector(state=>state.warning)
    const {openModalls,isOpenModal,openModallComment,closeModallComment,isModalCommentOpen,openModalls2,isOpenModal2,closeModalls2,isModalSensorCommentOpen,openModallSensorComment,openD,closeD,opens}=useGlobalContext()
    const [iindex,setIindex]=useState()
    const [itemm,setItemm]=useState({})
    const [importanceLevelList,setImporatnaceLevelList]=useState([])
    const dispatch=useDispatch()
    const getImportanceList=async()=>{
        const res=await apiService.getImportanceLevelList()
        setImporatnaceLevelList(res.data.data)
    }
    const getList=async()=>{
        dispatch(AddStatus([]))
        const res=await apiService.getStatusList()
        dispatch(AddStatus(res.data))
    }
    const getListComm=async()=>{
        dispatch(AddStatus([]))

        const res=await apiService.getCattleComment()
        dispatch(AddStatus(res.data))
    }
    const getListCommSens=async()=>{
        dispatch(AddStatus([]))

        const res=await apiService.getSensorComment()
        dispatch(AddStatus(res.data))
    }
    const getListCycle=async()=>{
        dispatch(AddStatus([]))

        const res=await apiService.getCattleCycleStatusList()
        dispatch(AddStatus(res.data))
    }
    const getListSensor=async()=>{
        dispatch(AddStatus([]))

        const res=await apiService.getSensorStatusList()
        dispatch(AddStatus(res.data))
    }
    const getOrderCycle=async()=>{
        dispatch(AddStatus([]))

        const res=await apiService.getOrderCycle()
        dispatch(AddStatus(res.data.data))
    }
    const getTypePens=async()=>{

        const res=await apiService.getTypePens({'isActive':null});
        dispatch(AddStatus(res.data))
        
    }
    const getTypePensComm=async()=>{
        const res=await apiService.getPensCommentsTypes();
        dispatch(AddStatus(res.data))
    }
    const getTypeFarmComm=async()=>{
        const res=await apiService.getCommentFarmTypes();
        dispatch(AddStatus(res.data))
    }
    const toggleUser=async(id,index)=>{
        const res=await apiService.togglePenType(id);
        const editedList = [
            ...currentWarings.slice(0,index),
            res.data,
            ...currentWarings.slice(index+1)
          ];
        dispatch(AddStatus(editedList))
  
      }
    useEffect(()=>{
        
        switch(flag){
            case 1:getList();getImportanceList();
            break;
            case 2:getListSensor();getImportanceList()
            break;
            case 3:getListCycle()
            break;
            case 4:getListComm()
            break;
            case 5:getListCommSens();
            break;
            case 6:getOrderCycle();
            break;
            case 7:getTypePens();
            break;
            case 8:getTypePensComm();
            break;
            case 9:getTypeFarmComm();
            break;
        }
    },[])
  return (
    <div className='d-flex justify-content-center justify-content-lg-start' style={{width:'100%',textAlign:'center',display:'flex',gap:'10px',flexWrap:'wrap',margin:'10px',position:'relative'}}>
        {(flag==1||flag==2)&&<div className='importanceNav'> <span style={{fontWeight:'bold'}}>میزان اهمیت :</span>
            {flag!=6&&importanceLevelList?.map((item,index)=>{
        return <div key={index} style={{color:`${colors[item?.id-1]}`,textShadow:'1px 1px 2px black'}}>
            {item?.description}
        </div>
    })}
            </div>}
        {flag!=6&&<div className='cardSett cardSettPlus' onClick={openModallComment}>
            
            <AddBoxOutlinedIcon fontSize='large'/>
            
        </div>}
        {flag==6&&<div className='cardSett cardSettPlus' onClick={openModalls2}>
            
            <AddBoxOutlinedIcon fontSize='large'/>
            
        </div>}
    {flag==6&&currentWarings?.map((item,index)=>{
        return <div key={index} className='cardSett'>
           از {item?.fromCattleLifeCycle?.title} به {item?.toCattleLifeCycle?.title}
            <div className='d-flex justify-content-between'>
            <div onClick={()=>{setIindex(index);openModallSensorComment();setItemm(item)}} data-title='به روز رسانی' className={S.EditBtnTableDam}>
                <Edit/>
            </div>
            <div onClick={()=>{openD();setItemm(item)}} data-title='به روز رسانی' style={{color:'#6b1805'}} className={S.EditBtnTableDam}>
                <Delete/>
            </div>
            </div>
        </div>
    })}
    
    {flag!=6&&currentWarings?.map((item,index)=>{
        return <div key={index} className='cardSett' style={{borderRightColor:`${colors[item?.importanceLevel-1]}`}}>
            {item?.title}
            <span>
            </span>
            <div onClick={()=>{setIindex(index);openModalls();setItemm(item)}} data-title='به روز رسانی' className={S.EditBtnTableDam}>
                <Edit/>
            </div>
            {flag===7&&<Switch color="success" checked={item?.isActive} onChange={()=>toggleUser(item?.id,index)} />}
        </div>
    })}
    
    {isOpenModal&&<EditStatus important={importanceLevelList} iindex={iindex} penr={itemm} toggle={"edit"} flag={flag}/>}
    {isModalCommentOpen&&<EditStatus important={importanceLevelList} iindex={iindex}  toggle={"add"} flag={flag}/>}
    {isOpenModal2&& <CycleOrderModal iindex={iindex} toggle={'add'}/>}
    {isModalSensorCommentOpen&& <CycleOrderModal iindex={iindex} penr={itemm} toggle={'edit'}/>}
    {opens&&<DeleteComm type={'cycle'} penr={itemm?.id}/>}
    </div>
  )
}

export default CattleStatusList
